import request from '@/utils/request'

// 用户列表
export function fetchList(data) {
	return request({
		url: '/oms/user/list',
		method: 'POST',
		data
	})
}

// 用户详情
export function getConsumerDetail(params) {
	return request({
		url: '/oms/user/detail',
		method: 'GET',
		params
	})
}

// 用户Note列表
export function fetchUserNoteList(data) {
	return request({
		url: '/oms/user/note/list',
		method: 'POST',
		data
	})
}

//新增用户
export function addUser(data) {
	return request({
		url: '/oms/user/add',
		method: 'POST',
		data
	})
}

//用户查询
export function searchUser(query){
	return request({
		url: '/oms/user/search',
		method: 'GET',
		params: {query}
	})
}

// 采购员列表
export function fetchPurchaserList(userId) {
	return request({
		url: '/oms/user/purchaser/list',
		method: 'GET',
		params: {userId}
	})
}

// 新增采购员
export function addPurchaser(data) {
	return request({
		url: '/oms/user/purchaser/add',
		method: 'POST',
		data
	})
}

// 删除采购员
export function deletePurchaser(data) {
	return request({
		url: '/oms/user/purchaser/delete',
		method: 'POST',
		data
	})
}

// 顾客地址列表
export function fetchConsumerAddressList(userId) {
	return request({
		url: '/oms/user/address/list',
		method: 'GET',
		params: {userId}
	})
}

// 顾客地址详情
export function getConsumerAddressDetail(params) {
	return request({
		url: '/oms/user/address/detail',
		method: 'GET',
		params
	})
}

// 新增顾客地址
export function addConsumerAddress(data) {
	return request({
		url: '/oms/user/address/add',
		method: 'POST',
		data
	})
}

// 编辑顾客地址
export function updateConsumerAddress(data) {
	return request({
		url: '/oms/user/address/update',
		method: 'POST',
		data
	})
}

// 删除顾客地址
export function deleteConsumerAddress(data) {
	return request({
		url: '/oms/user/address/delete',
		method: 'POST',
		data
	})
}



// WEBPACK FOOTER //
// ./src/api/cs/consumer.js